<template>
  <b-modal title="Informações do Cliente" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Título:" label-for="titulo" label-cols-sm="3" label-align-sm="right">
            <b-form-textarea id="titulo" v-model="editing.titulo" rows="3" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Local:" label-for="local" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="local" v-model="editing.local" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group
            label="Cliente:"
            label-for="cliente"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="cliente" v-model="editing.cliente" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col offset="10" cols="1">
          <b-form-select v-model="selecionado">
            <b-form-select-option
              v-for="cliente of clienteStore.clientes"
              v-bind:key="cliente.id"
              :value="cliente"
              >{{ cliente.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group
            label="Responsável:"
            label-for="responsavel"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input id="responsavel" v-model="editing.responsavel" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useClienteStore } from "@/stores/ClienteStore";
import Orcamento from "@/models/Orcamento";

export default {
  name: "ModalDeOrcamentoHead",

  data() {
    return {
      show: false,
      selecionado: null,
      editing: new Orcamento(),
    };
  },

  watch: {
    selecionado: function (cliente) {
      this.editing.cliente = cliente.nome;
    },
  },

  methods: {
    call(orcamento) {
      this.show = !this.show;
      this.editing = orcamento;
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();

    return {
      store,
      usuario: store.getUser,
      clienteStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
